import { EMPTY_STRING } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const QA_NAME_REQUEST_PROFILE_TAB_INTERNAL_TASKS = 'internal_tasks'

export const QA_NAME_ADD_CHECKLIST_BUTTON = 'add_internal_tasks_list'

export const QA_NAME_CREATE_CHECKLIST_MODAL = 'create_internal_tasks_list_modal'

export const QA_NAME_CREATE_CHECKLIST_SUBMIT =
  'create_internal_tasks_list_submit'

export const QA_NAME_ADD_CHECKLIST_ITEM_BUTTON = 'add_internal_task'

export const QA_NAME_DELETE_CHECKLIST_BUTTON = 'delete_internal_tasks_list'

export const QA_NAME_DELETE_CHECKLIST_ITEM_BUTTON = 'delete_internal_task'

export const QA_NAME_CHECKLIST_ITEM_CHECKBOX = 'internal_task_checkbox'

export const QA_NAME_CHECKLIST_ITEM_TEXT = 'internal_task_text'

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_CHECKLIST_ITEM_MAX_LENGTH = 2000

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_NAME_MAX_LENGTH = 255

export const CREATE_CHECKLIST_FIELD_NAME_TITLE = 'title'

export const CREATE_CHECKLIST_FIELD_NAME_TEMPLATE = 'template'

export const CREATE_CHECKLIST_FORM_INITIAL_VALUES = {
  [CREATE_CHECKLIST_FIELD_NAME_TEMPLATE]: FORMIK_EMPTY_VALUE,
  [CREATE_CHECKLIST_FIELD_NAME_TITLE]: EMPTY_STRING,
}

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY = {
  listDeleted: 'RequestProfile.InternalTasksListDeletedKey',
  taskAdded: 'RequestProfile.InternalTasksTaskAddedKey',
  taskDeleted: 'RequestProfile.InternalTasksTaskDeletedKey',
}
